import type { InterventionAssignFormProps } from "./intervention-assign-form.type";

import { ModelAssignForm } from "@/modules/model-assign";

import { useInterventionAssignForm } from "./intervention-assign-form.hook";

export const InterventionAssignForm = ({
  intervention,
  options,
}: InterventionAssignFormProps) => {
  const { onFormSubmit, status, error } = useInterventionAssignForm({
    intervention,
    options,
  });

  return (
    <ModelAssignForm
      existingUsers={intervention.users}
      onSubmit={onFormSubmit}
      status={status}
      error={error}
    />
  );
};
